<template>
  <div id="product-detail-bottom-container" v-bind:class="{ 'product-detail-page': page === 'detail' }">
    <v-layout>
      <v-flex xs6 class="pl-2 pt-2 pr-1 pb-2">
        <v-btn block outline color="primary" v-on:click="clickClose()" class="pa-0 ma-0">{{ $t('Cancel') }}</v-btn>
      </v-flex>
      <v-flex xs6 class="pl-1 pt-2 pr-2 pb-2">
        <variant-button
          v-if="page === 'detail' && (getProductDetail.product_attribute !== null && parseInt(getProductDetail.product_attribute.length) > 0)"
          from="bottom"
        ></variant-button>
        <v-btn depressed v-else-if="parseInt(getProductDetail.product.stock) - quantity < 0 && parseInt(getProductDetail.product.use_stock) === 1" class="disabled-button ma-0">{{ $t('Buy_now') }}</v-btn>
        <add-to-cart
          class="product-detail-buy-now-component"
          v-else-if="typeof getProductDetail.product !== 'undefined'"
          v-bind:product-sku="getProductDetail.product.sku"
          v-bind:product-quantity="quantity"
          open-cart="true"
          v-bind:rp-label="$t('Buy_now')"
          mode="custom">
        </add-to-cart>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VariantButton from '../productPrice/productVariantButton'

export default {
  name: 'ButtonBottom',
  components: {
    VariantButton
  },
  props: {
    page: {
      default: function () { return '' },
      type: String
    },
    quantity: {
      default: 1,
      type: Number
    }
  },
  data: () => {
    return {
      data: ''
    }
  },
  computed: {
    ...mapGetters([
      'getProductDetail'
    ])
  },
  methods: {
    clickClose () {
      if (this.page === 'detail') {
        this.$router.push({name: 'ProductList'})
      } else {
        this.$parent.$emit('modalActive', false)
      }
    }
  }
}
</script>

<style type='text/css' lang='scss' scoped>
#product-detail-bottom-container {
  bottom: 0px;
  width: 100%;

  .disabled-button {
    background-color: #dddddd;
    color: #bdbdbe;
    width: 100%;
    height: 100%;
    /*background-color: rgb(204, 207, 255);
    border-color: rgb(204, 207, 255);
    color: #000;*/
  }

  &.product-detail-page {
    background-color: #eeeeee;
    -webkit-box-shadow: 0px -1px 3px rgba(50, 50, 50, 0.25);
    -moz-box-shadow: 0px -1px 3px rgba(50, 50, 50, 0.25);
    box-shadow: 0px -1px 3px rgba(50, 50, 50, 0.25);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productDetail/bottom/index.vue